// Özel anahtarların durduğu yer — tek kapı (9.34 · D-633).
//
// KUSUR. Şifreleme bugüne kadar doğrudan `expo-secure-store`'u çağırıyordu ve o
// modülün web karşılığı BOŞ bir nesne: tarayıcıda `getValueWithKeyAsync` diye
// bir şey yok, çağrı `TypeError` atıyor. Sonuç sessizdi — anahtar kaydı
// açılışta düşüyor, yakalanıyor, günlüğe bir satır yazıyor; kullanıcı hiçbir şey
// görmüyordu. Web'den yazılan mesaj DÜZ METİN gidiyor, telefondan gelen şifreli
// mesaj ise açılamıyordu. İnsan şifreli sandığı bir yerde şifresiz yazıyordu.
//
// TELEFON İLE TARAYICI AYNI ŞEY DEĞİL, ve bu gizlenmemeli. Telefonda özel
// anahtar Keychain/Keystore'da durur; işletim sistemi onu başka uygulamalardan
// ve çoğu durumda cihazın kilidinden korur. Tarayıcıda öyle bir kasa YOK.
// Buradaki koruma şuna karşıdır: sunucu ve ağ. Şuna karşı değildir: bizim
// alan adımızda çalışan kötü niyetli bir betik. WhatsApp Web ve Signal Desktop
// da tam olarak bu takası yapıyor; başka bir seçenek tarayıcıda mevcut değil.
//
// NEDEN localStorage, IndexedDB değil: anahtar malzemesi küçük (kimlik + imzalı
// prekey + 100 tek-kullanımlık prekey ≈ 10 KB), ikisi de aynı kökene bağlı ve
// aynı "site verilerini temizle" ile silinir, yani güvenlik farkı yok. Fark
// yalnız karmaşıklıkta. Kripto saf JS ve anahtarlar zaten dize; IndexedDB'nin
// çıkarılamaz CryptoKey avantajı bu tasarımda kullanılamıyor.
import { Platform } from 'react-native';
import * as SecureStore from 'expo-secure-store';

/** Anahtarların yazıldığı yerin sözü. Yerli ve web karşılıkları bunu doldurur. */
export type AnahtarDeposu = {
  get(key: string): Promise<string | null>;
  set(key: string, value: string): Promise<void>;
  remove(key: string): Promise<void>;
  /** Depo gerçekten yazılabiliyor mu. Gizli sekmede yanlış olabilir. */
  kullanilabilir(): boolean;
};

// Web tarafında anahtarların önüne konan ad alanı. AsyncStorage da tarayıcıda
// aynı `localStorage`'ı kullanıyor; ayrı önek, iki depoyu okuyan bir insanın
// hangisinin ne olduğunu görmesini sağlıyor.
export const WEB_ONEK = 'nosubject.e2ee.';

/**
 * Tarayıcı deposu. `Storage` dışarıdan veriliyor ki sınanabilsin ve gizli
 * sekmede erişimin kendisi patladığında yakalanabilsin.
 */
export function webDeposu(store: Storage | undefined): AnahtarDeposu {
  const yaz = (k: string) => `${WEB_ONEK}${k}`;
  return {
    async get(key) {
      if (!store) return null;
      return store.getItem(yaz(key));
    },
    async set(key, value) {
      if (!store) throw new Error('Tarayıcı deposu yok');
      store.setItem(yaz(key), value);
    },
    async remove(key) {
      if (!store) return;
      store.removeItem(yaz(key));
    },
    kullanilabilir() {
      if (!store) return false;
      // Gizli sekmede `localStorage` VAR ama yazmak atabiliyor. Varlığına
      // bakmak yetmez; deneyip geri almak gerekir.
      const deneme = `${WEB_ONEK}probe`;
      try {
        store.setItem(deneme, '1');
        store.removeItem(deneme);
        return true;
      } catch {
        return false;
      }
    },
  };
}

/** Telefon deposu: işletim sisteminin kasası. */
export const yerliDepo: AnahtarDeposu = {
  get: (key) => SecureStore.getItemAsync(key),
  set: (key, value) => SecureStore.setItemAsync(key, value),
  remove: (key) => SecureStore.deleteItemAsync(key),
  kullanilabilir: () => typeof SecureStore.setItemAsync === 'function',
};

function seç(): AnahtarDeposu {
  if (Platform.OS !== 'web') return yerliDepo;
  const g = globalThis as { localStorage?: Storage };
  // Erişimin KENDİSİ atabiliyor (bazı gizlilik ayarlarında), o yüzden sarmalı.
  let store: Storage | undefined;
  try {
    store = g.localStorage;
  } catch {
    store = undefined;
  }
  return webDeposu(store);
}

const depo = seç();

// D-711 — anahtarlar CİHAZA değil HESABA ait.
//
// KUSUR (D-708'de simülatörde görüldü). Kimlik, oturum ve doğrulama anahtarları
// hesaptan bağımsız adlarla saklanıyordu ve çıkış onları silmiyordu. Aynı
// cihazda başka bir hesap açılınca İLK hesabın kimliğiyle kaydoluyor, aynı
// kişilerle aynı ratchet oturumlarını paylaşıyordu. Batuhan: "düzelt."
//
// ÇÖZÜM. Her anahtarın adı oturum açan hesabın numarasıyla önekleniyor
// (`acct.<id>.`). Eski, öneksiz anahtarlar (D-711 öncesi kurulumlar) kaybolmasın
// diye ait oldukları hesaba bırakılıyor: o hesap öneksiz adları kullanmaya devam
// ediyor, başka hesaplar kendi önekleriyle ayrı bir dünya kuruyor. Hangi hesabın
// eski anahtarların sahibi olduğuna `account.ts` dizine bakarak karar veriyor.
// Çıkış anahtarları SİLMEZ: aynı hesap geri gelince geçmişi ve kimliği yerindedir.
let kapsam: { hesap: number | null; eskiSahibi: boolean } = { hesap: null, eskiSahibi: false };
let hazir: Promise<void> = Promise.resolve();

/** Anahtarın depodaki adı: hesabın öneki, ya da eski anahtarların sahibi için önek yok. */
export function scopedKey(key: string, scope: { hesap: number | null; eskiSahibi: boolean }): string {
  return scope.hesap === null || scope.eskiSahibi ? key : `acct.${scope.hesap}.${key}`;
}

/** `account.ts` kapsamı belirlerken bekleyen bir söz verir; okuma ve yazma onu bekler. */
export function setKeyScope(next: Promise<{ hesap: number | null; eskiSahibi: boolean }>): Promise<void> {
  hazir = next.then((k) => { kapsam = k; }, () => {});
  return hazir;
}

/** Kapsam dışı okuma/yazma: yalnız eski anahtarların sahibini kaydetmek için. */
export const getUnscopedSecret = (key: string): Promise<string | null> => depo.get(key);
export const setUnscopedSecret = (key: string, value: string): Promise<void> => depo.set(key, value);

export const getSecret = async (key: string): Promise<string | null> => {
  await hazir;
  return depo.get(scopedKey(key, kapsam));
};
export const setSecret = async (key: string, value: string): Promise<void> => {
  await hazir;
  return depo.set(scopedKey(key, kapsam), value);
};
export const deleteSecret = async (key: string): Promise<void> => {
  await hazir;
  return depo.remove(scopedKey(key, kapsam));
};

/**
 * Bu ortamda şifreleme kurulabilir mi.
 *
 * Çağrılmayan bir kontrol, olmayan bir kontroldür: bu fonksiyonun eski hâli
 * dosyada duruyordu ama hiçbir yerden çağrılmıyordu, web'in sessizce şifresiz
 * kalmasının sebeplerinden biri de buydu. Artık açılış onu soruyor.
 */
export const secureStorageAvailable = (): boolean => depo.kullanilabilir();
